import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { ReactNode } from "react";

type InputFieldProps = {
  value: string;
  setter: (string) => void;
  label?: string;
  error?: boolean;
  errorType?: string;
  disabled?: boolean;
  readOnly?: boolean;
  type?: string;
  className?: string;
  inputClassName?: string;
  endAdornment?: ReactNode;
  showLabel?: boolean;
  multiline?: boolean;
  rows?: number;
  placeholder?: string;
};

const InputField = ({
  value,
  setter,
  label,
  error,
  errorType,
  disabled,
  readOnly = false,
  type = "text",
  endAdornment,
  showLabel = false,
  multiline = false,
  rows = 0,
  placeholder = "",
  className = "",
  inputClassName = "",
}: InputFieldProps) => {
  return (
    <TextField
      value={value}
      onChange={e => setter(e.target.value)}
      label={label}
      variant="outlined"
      type={type}
      className={`w-full outlined-input labelText ${className}`}
      error={error}
      helperText={errorType}
      disabled={disabled}
      InputProps={{
        readOnly,
        className: inputClassName,
        endAdornment: endAdornment
          ? (
              <InputAdornment position="end">{endAdornment}</InputAdornment>
            )
          : undefined,
      }}
      InputLabelProps={{
        shrink: showLabel,
      }}
      multiline={multiline}
      rows={rows}
      placeholder={placeholder}
    />
  );
};

export default InputField;
